// import { format as formatDate } from 'date-fns';

// always use dutch formatting rules for now...
const FORMAT_LOCALE = "nl-NL";

const DECIMAL_FORMAT = {
    style: "decimal"
}

const DOUBLE_FORMAT = {
    style: "decimal",
    maximumFractionDigits: 2,
    useGrouping: false
}

const INTEGER_FORMAT = {
    style: "decimal",
    useGrouping: false
}
    
const DATE_FORMAT = {
    dateStyle: "short"
}

const TIME_FORMAT = {
    timeStyle: "medium",
    hourCycle: "h23"
}

const applyNumberFormat = (value, format) => {
    let string = null;
    
    if( !isNullOrUndefined(value) ) {
        string = new Intl.NumberFormat(FORMAT_LOCALE, format).format(value);
    }
    
    return string;
}

const applyDateFormat = (dateValue) => {
    let string = null;
    if( dateValue ) {
        const parts = new Intl.DateTimeFormat(FORMAT_LOCALE, DATE_FORMAT).formatToParts(dateValue);
        
        // HACK HACK HACK javascript does not support an easy year-month-day format
        // TODO: date format?
        let year, month, day;
        parts.forEach(({type, value}) => {
            if( type === 'year' ) {
                year = value;
            } else if( type === 'month' ) {
                month = value;
            } else if( type == 'day' ) {
                day = value;
            }
        })
        
        string = `${year}-${month}-${day}`;
    }
    
    return string;
}

const applyTimeFormat = (value) => {
    let string = null;
    if( value ) {
        string = new Intl.DateTimeFormat(FORMAT_LOCALE, TIME_FORMAT).format(value);
    }
    
    return string;
}

const buildNumberFormat = (format, options) => {
    return Object.assign({}, format, (options || {}));
}

const formatDecimal = (value, options) => applyNumberFormat(value, buildNumberFormat(DECIMAL_FORMAT, options));
const formatDouble = (value, options) => applyNumberFormat(value, buildNumberFormat(DOUBLE_FORMAT, options));
const formatLong = (value, options) => applyNumberFormat(value, buildNumberFormat(INTEGER_FORMAT, options));

const formatDate = (year, month, day) => applyDateFormat(new Date(year, month - 1, day));
const formatTime = (hour, minute, seconds) => applyTimeFormat(new Date(0, 0, 0, hour, minute, seconds));

const isNullOrUndefined = (value) => value === undefined || value === null

const formatDateTime = (epoch) => {
    const dateValue = new Date(epoch);
    const date = applyDateFormat(dateValue);
    const time = applyTimeFormat(dateValue);
    
    return `${date} ${time}`;
}

const format = {
    formatDecimal,
    formatDouble,
    formatLong,
    formatDate,
    formatDateTime,
    formatTime
}

export {
    format, formatDecimal, formatDateTime
}